import {Table} from "antd";

const resultTreatmentFileTypeLabels = {
    pv: 'PV',
    bon_a_lancer: 'Bon à lancer',
    piece_jointe: 'Pièce jointe',
    be_precloture: 'BE',
    be_cloture: 'BE',
};

const Attachments = ({attachments}) => {
    const columns = [
        {
            title: 'Fichier',
            dataIndex: 'fichier',
            key: 'fichier',
            render: (fichier) => fichier.libelle
        },

        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (type) => resultTreatmentFileTypeLabels[type] || type
        },

        {
            title: 'Actions',
            render: (record) => <a target='_blank' rel="noreferrer" href={record.fichier.path}>Voir le fichier</a>
        }
    ]

    return <Table
        columns={columns}
        dataSource={attachments}
        className="custom-table mt-4" />
}

export default Attachments